import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

import { FormsUtilsService, MessageService, notCloseMessageOptions } from '../../../../core';
import { CollapseGroupComponent } from '../../../../shared';
import { PessoaEndereco, } from '../pessoa-endereco';
import { isEnderecoTipoPrincipal, isEnderecoTipoCobranca, isEnderecoTipoEntrega } from '../pessoa-endereco-tipo';
import { PessoaEnderecoCidadeComponent } from '../cidade';
import { Cep } from '../../../../core/services/cep';
import { pessoaTipoCadastro } from '../../pessoa-tipo-cadastro';
import { isTipoPessoaFisicaOuJuridica } from '../../tipo';
import { PessoaContato, PessoaContatoUnicoComponent } from '../../contato';

interface Config {
    isEnderecoPrincipal: boolean;
    isEnderecoCobranca: boolean;
    isEnderecoEntrega: boolean;
    isCliente: boolean;
    // Acessos
    isShowInscricoes: boolean;
}

@Component({
    selector: 'sgt-pessoa-endereco-unico',
    templateUrl: './pessoa-endereco-unico.component.html',
    styleUrls: ['./pessoa-endereco-unico.component.less']
})
export class PessoaEnderecoUnicoComponent implements OnInit, OnChanges {
    config: Config;

    /** Se pode editar os dados do form do endereço da pessoa */
    @Input() canEdit = true;
    @Input() tipoPessoa: number;
    @Input() tipoEndereco: number;
    @Input() entity: PessoaEndereco;
    @Output() entityChange = new EventEmitter<PessoaEndereco>();
    @Input() idRepresentante: number;
    @Input() tipoCadastro: number;
    @Input() clienteCadastro: number;
    @Input() permiteExcluir = true;

    // Endereço
    @Input() enderecoCollapseGroupTitle = 'Endereço'; // Título do collapse group do endereço
    @Input() isEnderecoCollapsedInDefault = true; // Se o collapse group do endereço está por padrão aberto
    @Input() cepRequired = true; // Se o CEP deve ser obrigatório
    @Input() logradouroRequired = true; // Se o logradouro deve ser obrigatório
    @Input() numeroRequired = true; // Se o número deve ser obrigatório
    @Input() bairroRequired = true; // Se o bairro deve ser obrigatório
    @Input() inscricaoEstadualRequired = false;
    @Input() exibirInscricaoSuframa = true;
    @Input() exibirInscricaoProdutorRural = true;
    @Input() exterior = false; // Se for um endereço de uma pessoa do exterior
    /** Input se possui ou não Inscrição Suframa */
    @ViewChild('possuiInscricaoSuframaInput') possuiInscricaoSuframaInput: ElementRef;
    /** Input da Inscrição Suframa */
    @ViewChild('enderecoInscSuframaInput') enderecoInscSuframaInput: ElementRef;

    // Contato
    @Input() contatoCollapseGroupTitle = 'Contato'; // Título do collapse group do endereço
    @Input() isContatoCollapsedInDefault = true; // Se o collapse group do contato está por padrão aberto
    @Input() telefoneRequired = true;
    @Input() celularRequired = false;
    @Input() emailRequired = false;
    @Input() tipoContato: number;
    @Input() entityContato: PessoaContato;
    @Output() entityContatoChange = new EventEmitter<PessoaContato>();
    @ViewChild('pessoaContato') pessoaContato: PessoaContatoUnicoComponent;

    @ViewChild('form') form: NgForm;
    @ViewChild('formCidade') formCidade: PessoaEnderecoCidadeComponent;

    constructor(private formsUtilsService: FormsUtilsService,
                private messageService: MessageService) { }

    ngOnInit(): void {
        this.setConfig();
    }


    ngOnChanges(changes: SimpleChanges) {
        for (const propName in changes) {
            // Quando existir o endereço
            if (propName === 'entity') {
                if (changes[propName].isFirstChange()) {
                    if (this.entity) {
                        // Setando a UF da máscara da IE
                        // if (this.entity.cidade) {
                        //     this.ufMascaraIe = this.entity.cidade.estado.uf;
                        // }
                    }
                }
            }
        }
    }

    private setConfig() {
        this.config = {
            isEnderecoPrincipal: isEnderecoTipoPrincipal(this.tipoEndereco),
            isEnderecoCobranca: isEnderecoTipoCobranca(this.tipoEndereco),
            isEnderecoEntrega: isEnderecoTipoEntrega(this.tipoEndereco),
            isCliente: this.tipoCadastro && this.tipoCadastro === pessoaTipoCadastro.cliente,
            isShowInscricoes: isTipoPessoaFisicaOuJuridica(this.tipoPessoa)
        }
    }

   /** Verifica se pode adicionar o endereço quando o mesmo não estiver cadastrado */
   canInsert(): boolean {
        // Se não puder editar, então não pode adicionar o endereço
        if (!this.canEdit) {
            return false;
        }

        return true;
    }

    /** Verifica se pode excluir o endereço */
    canDelete(): boolean {
        // Se não puder editar, então não pode excluir o endereço
        if (!this.canEdit) {
            return false;
        }

        return this.permiteExcluir;
    }

    /** Verifica se pode salvar o endereço quando o mesmo não estiver cadastrado */
    canSave(): boolean {
        // Se não puder editar, então não pode salvar o endereço
        if (!this.canEdit) {
            return false;
        }

        return true;
    }

    /** Quando o CEP for encontrado, setamos os valores nos campos do endereço */
    onCepEncontrado(cep: Cep) {
        if (cep) {
            this.entity.logradouro = cep.logradouro;
            this.entity.bairro = cep.bairro;
            this.entity.complemento = cep.complemento;
            this.formCidade?.setDadosCep(cep);
            // this.ufMascaraIe = cep.cidade.estado.uf;
        }
    }


    insert() {
        this.entity = new PessoaEndereco(this.tipoEndereco);
        this.entityChange.emit(this.entity);
        this.formCidade?.insert();

        // Insirindo o contato
        setTimeout(() => {
            this.pessoaContato.insert();
        }, 200);
    }

    /** Seta o pais e cidade conforme se for um endereço de exterior ou não */
    setCidadeEPais() {
        this.formCidade?.insert();
    }

    /** Carrega as sub-regiões da cidade informada e representante */
    carregarSubRegioesDaCidade() {
        this.formCidade?.carregarSubRegioes();
    }

    /** Carrega os bairros da sub-região informada */
    carregarBairrosDaSubRegiaoDaCidade() {
        this.formCidade?.carregarBairrosDaSubRegiao();
    }

    delete() {
        this.messageService.confirm('Deseja realmente excluir este endereço?', 'Confirme').then(result => {
            if (result) {
                this.entity = null;
                this.entityChange.emit(null);

                // Excluindo o contato vinculado
                this.pessoaContato.delete();
                this.entityContatoChange.emit(null);
            }
        });
    }

     /** Verifica se o endereço único está válido */
    isValid(): boolean {
        // Se não puder salvar então retoramos como form válido para não dar erros de campos inválidos
        if (!this.canSave()) {
            return true;
        }

        if (this.entity) {
            // Inscrição Suframa
            if (this.config.isShowInscricoes && this.exibirInscricaoSuframa) {
                // Flag se possui ou não inscrição não selecionada
                if (this.entity.possuiInscricaoSuframa == null || this.entity.possuiInscricaoSuframa === undefined) {
                    this.messageService.warning('Selecione se este cliente possui ou não inscrição Suframa', 'Atenção', notCloseMessageOptions);
                    setTimeout(() => jQuery(this.possuiInscricaoSuframaInput.nativeElement).trigger('focus'), 300);
                    return false;
                }
                // Cliente possui inscrição mas inscrição não informada
                if (this.entity.possuiInscricaoSuframa && (!this.entity.inscricaoSuframa || this.entity.inscricaoSuframa.trim().length === 0)) {
                    this.messageService.warning('Cliente selecionado que possui inscrição Suframa mas inscrição não informada. Informe a Inscrição Suframa e tente novamente', 'Atenção', notCloseMessageOptions);
                    setTimeout(() => jQuery(this.enderecoInscSuframaInput.nativeElement).trigger('focus'), 300);
                    return false;
                }
            }
        }


        // Se o formulário do endereço ou da cidade não estiverem válidos, retornamos que o endereço não está válido
        this.formsUtilsService.makeAllFieldsDirty(this.form);
        if (!this.form.valid || (this.formCidade && !this.formCidade.isValid())) {
            this.messageService.warning('Para salvar é preciso informar corretamente o endereço e todos os seus campos destacados em vermelho', 'Atenção', notCloseMessageOptions);
            return false;
        }

        // Validando o Contato
        if (this.pessoaContato && !this.pessoaContato.isValid()) {
            return false;
        }

        return true;
    }

    onChangeContato(entityContato: PessoaContato) {
        this.entityContatoChange.emit(entityContato);
    }
}
